import { render, staticRenderFns } from "./MotoAdd.vue?vue&type=template&id=72bc02bd&scoped=true&"
import script from "./MotoAdd.vue?vue&type=script&lang=js&"
export * from "./MotoAdd.vue?vue&type=script&lang=js&"
import style0 from "./MotoAdd.vue?vue&type=style&index=0&id=72bc02bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc02bd",
  null
  
)

component.options.__file = "MotoAdd.vue"
export default component.exports